import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import queryString from "query-string";

import { Title, Body, Subtitle, Micro,Feature } from '@vds/typography'; 
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { TextLink, Button  } from '@vds/buttons';
import { Input } from '@vds/inputs';
import { UnorderedList, ListItem } from '@vds/lists'
import { Grid, Row, Col } from '@vds/grids';
import InnerHTML from 'dangerously-set-html-content'
import Zipcode from "./Zipcode/Zipcode";
import StreetAddress from '../AddressValidationPage/StreetAddress/StreetAddress'
import Unit from '../AddressValidationPage/Unit/Unit'
import CheckAvailability from '../AddressValidationPage/CheckAvailability/CheckAvailability'
import ExistingCustomer from '../AddressValidationPage/ExistingCustomer/ExistingCustomer'
import PendingOrder from '../AddressValidationPage/PendingOrder/PendingOrder';
import SpinnerComponent from '../../Common/Spinner/Spinner';
import AddressConfirmation from "./AddressConfirmation/AddressConfirmation";
import styled from 'styled-components';
import ChatLink from "../../Common/ChatLink/ChatLink";
import {
    setHasMutipleAddress, enableCheckAvailblityButton, resetZipcodeForm, enableCheckAvailblity, disableCheckAvailblity, setBannerInfo, setNewAddressFlow,
    setExistingCustomer, setAddressInfo, redirectLBOPage, hasPendingOrder, showSpinner, resetDoLoopFlags, checkAvailAPI,
    setEmptyUnitsError, multipleAddrSelectionsWithId, postUIEventLog, setDontShowUnit, getLqPageAds, setCityAndState,setRedirectedFrom, setcmpCodeQueryParams,
    setcmpCodeQueryParamsWireless, setBannerId
} from './../AddressValidationPage/containers/action';
import './AddressValidationPage.css'
import { Privacy, handleSignInClickEvent, isIEBrowser, isNightTimeWindow } from './../../utils/common';
import { EXISTING_USER_URL } from './../../containers/APIurls';
import * as SiteAnalytics from '../../sitecatalyst';
import { toggleGlobalErrorMessage, saveCurrentLocation, currentLocationFetchError, selectThisUnitAddress, useLocusApi  } from '../../containers/actions';
import { getChatInfo } from './containers/action';
import './AddressValidationPage.css';
import { ENABLE_OMNI_CART, ENABLE_AEM_CHANGES,STATE_SELECT, LQ_UNIT_ENABLE } from './../../containers/constants';
import map from 'lodash/map';
import isEmpty from 'lodash/map';
import find from 'lodash/find';
import { isBrowser, isMobile, isMobileOnly } from "react-device-detect";
import { DropdownSelect } from '@vds/selects';
import { MarginSpacerL, MarginSpacerM } from '../../Pages/Checkout/styleTag';
import { Notification } from '@vds/notifications';
import { fetchLocusInfo } from "../Checkout/containers/action";
import { withTranslation  } from 'react-i18next';
import { VZStepper } from "../../Common/HorizontalProgress/VZStepper";

const AddressTipsModal = styled(Modal)`
height: auto;
> div:first-child {overflow:hidden}
@media only screen and (max-width: 600px) {
    position: absolute;
    top: 10px;
    right:10px;
    left:9px;
    width: 95vw;
    height: 97vh;
    > div:first-child {
        padding:2px;
    }
}
`;

const ReadOnlyInput = styled(Input)`
input {
    border-bottom: 0.0625rem solid #000000 !important;
    border-left: 0.0625rem solid #d8dada !important;
    border-right: 0.0625rem solid #d8dada !important;
    border-top: 0.0625rem solid #d8dada !important;
    padding: 0.75rem 1rem;
}
`;

const ModGrid = styled(Grid)`
// margin-bottom: ${(props) => props.adSpaceHeight ? (props.adSpaceHeight + 'px') : '140px'} !important;
@media only screen and (max-width: 767px) {
    margin-bottom:  20px !important;
}
`

class AddressValidationPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showZip: true,
            showModal: false,
            streetValue: "",
            isCheckAvailability: false,
            addressError: false,
            isNewService: 'Y',
            streetAdressInfo: {},
            hasPriceQuote: 'N',
            ad: '',
            adSlotHeight: 0,
            adSpaceHeight: '',
            unitError: false,
            initiateChat: false,
            endInteraction: false,
            showIEBanner: true,
            currentAddressError:''
        };
        this.adRef = React.createRef(null);
        this.mainRef = React.createRef(null);
        window.scrollTo(0, 0);
        props.hideGlobalErrorMessage();
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        }
        // const self = this;
        // window.addEventListener('beforeunload', self.props.clearGlobalStore);
        window.localStorage.setItem('customizeProductsCompleted', "");
    }

    componentDidMount() {
        localStorage.removeItem('LOAD_FIOS_DATA')
        localStorage.removeItem('DATA_PLANS_EMPTY')
        window.scrollTo(0, 0);
        const addressData = this.props.addressData;
        this.props.clearGlobalStore();
        // this.props.presetAddressinfo(addressData);
        // this.props.initiateGlobalSession();
        this.props.setExistingCustomer(false);
        this.props.hasPendingOrder(false);
        this.props.enableCheckAvailblity(true);
        const values = queryString.parse(this.props.location.search);
        let redirectedFrom = values && values.redirectedFrom;
        if(!redirectedFrom) {
        redirectedFrom = document.referrer?.includes("lte")? "LTE" :  document.referrer?.includes("5g")? "5G": 
        document.referrer?.includes("fios")? "FIOS": document.referrer?.includes("options-for-business")?"BBA":"";
        }  
        this.props.setRedirectedFrom(redirectedFrom);
        const SMBBANNERID = values && values.SMBBANNERID;
        const bannerid=values && values.SMBBANNERID && values.SMBBANNERID.replace(/ /g, '+');
        if (SMBBANNERID) {
            this.props.setBannerInfo(SMBBANNERID);
        }
        if(bannerid){
            this.props.setBannerId(bannerid);
        }
        this.props.hideGlobalErrorMessage();
        this.props.saveCurrentLocation(window.location.pathname);
        window.localStorage.setItem('SOURCE', '');
        this.setState({ initiateChat: true });
        this.setState({ endInteraction: true });
        this.getLqPageAds();
        if(window.location.search){
            const params = queryString.parse(window.location.search)
            if(params!==null&&params&&typeof params == 'object'&&Object.keys(params).length){
                const {cmp} = params
                if(String(cmp).includes('fios_2q23')){
                    this.props.setcmpCodeQueryParams('fios_2q23')
                }else this.props.setcmpCodeQueryParamsWireless(cmp)
            }

        }
        // const locusApi = this.props.t("fios.useLocusApi", { ns: "fios"})
        // if(locusApi && locusApi === true)
        this.props.useLocusApi(true)
    }

    getLqPageAds = () => {
        if (ENABLE_AEM_CHANGES === 'true' || ENABLE_AEM_CHANGES === true) {
            this.props.getLqPageAds();
        }
    }

    componentDidUpdate() {
        if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
            window.newrelic.interaction().end();
            this.setState({ endInteraction: false });
        }
        if (this.adRef?.current && isBrowser && this.mainRef?.current?.clientHeight) {
            const mainContentHeight = this.mainRef.current.clientHeight;
            const adSlotHeight = this.getBiggestHeight(this.adRef.current);
            const defaultBottomMargin = 240;
            let adSpaceHeight = adSlotHeight > mainContentHeight ? (adSlotHeight - mainContentHeight) : defaultBottomMargin;
            adSpaceHeight = adSpaceHeight <= defaultBottomMargin ? defaultBottomMargin : adSpaceHeight;
            if (adSpaceHeight !== this.state.adSpaceHeight) {
                this.setState({ adSlotHeight, adSpaceHeight });
            }
        }
        if (this.state.initiateChat) {
            SiteAnalytics.trackPageInfo("LQ");
            this.props.getChatInfo("Addressvalidation");
            window.enableProactiveChat && window.enableProactiveChat();
            this.setState({ initiateChat: false });
        }
    }

    getBiggestHeight = (element) => {
        let height = element.clientHeight || 0;
        const childElements = element.querySelectorAll("div");
        childElements.forEach((child) => {
            if (child.clientHeight > height) {
                height = child.clientHeight;
            }
        });
        return height;
    };

    selectThisZipcode = (zipCode) => {
        this.setState({ streetValue: "", addressError: false, unitError: false });
        this.props.selectThisZipcode(zipCode);
        if (window?.newrelic?.addPageAction) {
            // window.newrelic.addPageAction('zipcode', {data: zipCode });
        }
    }

    selectThisUnit = (unit, isBlur, addressFound) => {
        let selectedUnit = unit.unit;
        const streetInfo = this.props.selectedStreetAddress;
        if (!isBlur || addressFound) {
            this.setState({ unitError: false });
        }
        if (selectedUnit === "noUnit") {
            this.props.selectThisUnit("");
            //Updating it for the case where you select no unit aftrer selecting any other uning
            streetInfo.ntasAddrID = streetInfo.baseAddressId;
        } else if (selectedUnit === "I don't live in a unit" || selectedUnit === "I don't have a unit" || selectedUnit === "I don't see my unit") {
            this.props.selectThisUnit(unit);
            streetInfo.ntasAddrID = streetInfo.baseAddressId;
        } else {
            if(unit && unit?.unitQuery) this.props.selectThisUnitAddress(unit?.unitQuery)
            this.props.selectThisUnit(unit);
            if (unit.addressId ) {
                streetInfo.ntasAddrID = unit.addressId;
            }
            // streetInfo.baseAddressId = unit.baseAddressId ||  "0";
            this.setState({
                streetAdressInfo: streetInfo
            })
            this.props.selectThisStreetAddress(streetInfo);
            if (window?.newrelic?.addPageAction) {
                // window.newrelic.addPageAction('unit', {data: {unit} });
            }
        }
        this.props.resetDoLoopFlags();
    };

    selectedStreetAddress = (street) => {         
        this.props.selectThisStreetAddress(street);
        this.props.selectThisUnit('');
        this.setState({ streetAdressInfo: street });
        if (window?.newrelic?.addPageAction) {
            // window.newrelic.addPageAction('street', {data: street }); 
        }
    };

    handleModal = (showModal) => {
        this.setState({ showModal });
    };

    getStreetValue = (value) => {
        const { streetAdressInfo } = this.state;
        if (!isEmpty(this.state.streetAdressInfo) && this.state.streetAdressInfo.street !== value) {
            streetAdressInfo.ntasAddrID = "";
        }
        this.setState({ streetValue: value, addressError: false, unitError: false });
    };

    validateAddress = () => {
        if (!this.props.selectedStreetAddress && !this.state.streetValue?.trim()) {
            this.setState({ addressError: true })
            return false;
        }
        return true;
    }

    validateUnits = () => {
        const { selectedStreetAddress, unitList, selectedUnit } = this.props;
        const streetInfo = this.props.selectedStreetAddress;
        if (selectedStreetAddress && unitList) {
            if (!selectedUnit) {
                this.setState({ unitError: true });
                if (this.validateAddress()) {
                    const inputContainer = document.getElementById("Unit-inputbox");
                    if (inputContainer) {
                        const inputs = inputContainer.getElementsByTagName("input");
                        if (inputs && inputs[0]) {
                            inputs[0].focus();
                        }
                        this.props.getUnits();
                    }
                }
                return false;
            } else {
                let flag = false;
                if (selectedUnit.unit === "I don't live in a unit" || selectedUnit.unit === "I don't have a unit" || selectedUnit.unit === "I don't see my unit") {
                    flag = true;
                } else {
                    map(unitList, unitObj => {
                        if (this.formatString(unitObj.unit) === this.formatString(selectedUnit.unit) || selectedUnit.unit === "I don't live in a unit" || selectedUnit.unit === "I don't have a unit" || selectedUnit.unit === "I don't see my unit") {
                            flag = true;
                            if (unitObj.addressId) {
                                streetInfo.ntasAddrID = unitObj.addressId;
                            }
                            this.setState({
                                streetAdressInfo: streetInfo
                            })
                            this.props.selectThisStreetAddress(streetInfo);
                        }
                    });
                }
                if (!flag) {
                    this.setState({ unitError: true });
                    if (this.validateAddress()) {
                        const inputContainer = document.getElementById("Unit-inputbox");
                        if (inputContainer) {
                            const inputs = inputContainer.getElementsByTagName("input");
                            if (inputs && inputs[0]) {
                                inputs[0].focus();
                            }
                            this.props.getUnits();
                        }
                    }
                    return flag;
                }
            }
        }
        return true;
    }

    formatString = str => {
        return str ? str?.replace(/\s/g, '')?.replace(/,/g, '')?.toLowerCase()?.trim() : "";
    }


    triggerAddressQualification = (historyObjectForNavigation, selectedStreetAddress) => {
        if (!this.props.selectedStreetAddress) {
            this.props.selectThisStreetAddress({ street: this.props.streetTermEnteredByUser });
        }
        this.setState({ showModal: false });
        const { selectedZipcode } = this.props
        this.props.triggerAddressQualification(historyObjectForNavigation, selectedStreetAddress, selectedZipcode);
        // if(ENABLE_OMNI_CART === "true") {
        // this.props.triggerOptixAddressQualification(historyObjectForNavigation)
        // }
        this.props.setNewAddressFlow(true)
    };

    onDropdownListDismiss = (isCheckAvailability) => {
        this.setState({ isCheckAvailability });
    };

    getFormatedAddress = (obj) => {
        if (obj.AddressId) {
            if (this.props.selectedZipcode && this.props.selectedZipcode.zip !== obj.ZipCode) {
                this.props.getZipcodes(obj.ZipCode.toString()?.trim(), true);
            }
            let splitTerm = obj.ElevationType || obj.UnitType;
            if (obj.ElevationType && obj.UnitType) {
                const elevationIndex = obj.ParsedRawString?.trim().indexOf(obj.ElevationType);
                const unitIndex = obj.ParsedRawString?.trim().indexOf(obj.UnitType);
                splitTerm = elevationIndex < unitIndex ? obj.ElevationType : obj.UnitType;
            }
            const street = splitTerm ? obj.ParsedRawString?.trim().split(splitTerm)[0] : obj.ParsedRawString?.trim();
            const { streetAdressInfo } = this.state;
            streetAdressInfo.ntasAddrID = obj.AddressId.toString().split(".")[0];
            streetAdressInfo.baseAddressId = "0";
            streetAdressInfo.street = street?.trim();
            const unit = obj.ParsedRawString?.trim().split(street?.trim())[1];
            streetAdressInfo.unit = unit?.trim();
            this.setState({
                streetAdressInfo,
                streetValue: obj.ParsedRawString?.trim(),
                addressError: false,
                unitError: false
            });
            this.props.selectThisStreetAddress(streetAdressInfo);

            // if(unit) {
            //     this.selectThisUnit({unit:unit.trim()});
            // } 
            this.props.multipleAddrSelectionsWithId(streetAdressInfo);
            // setTimeout(this.props.multipleAddrSelectionsWithId.bind(this), 2000);
        } else if (obj.UnitType || obj.ElevationType) {
            let splitTerm = obj.ElevationType || obj.UnitType;
            if (obj.ElevationType && obj.UnitType) {
                const elevationIndex = obj.ParsedRawString?.trim().indexOf(obj.ElevationType);
                const unitIndex = obj.ParsedRawString?.trim().indexOf(obj.UnitType);
                splitTerm = elevationIndex < unitIndex ? obj.ElevationType : obj.UnitType;
            }
            const street = splitTerm ? obj.ParsedRawString?.trim().split(splitTerm)[0] : obj.ParsedRawString?.trim();
            // const street = obj.ParsedRawString.trim().split(obj.ElevationType || obj.UnitType)[0];
            const unit = obj.ParsedRawString?.trim().split(street?.trim())[1];
            const { streetAdressInfo } = this.state;
            streetAdressInfo.ntasAddrID = "";
            streetAdressInfo.baseAddressId = "";
            streetAdressInfo.street = street?.trim();
            this.setState({
                streetAdressInfo,
                streetValue: street?.trim(),
                addressError: false,
                unitError: false
            });
            this.props.selectThisStreetAddress(streetAdressInfo);
            this.props.getMultipleAddrSelections({ street: street?.trim(), unit });
        } else {
            const street = obj.ParsedRawString?.trim();
            const { streetAdressInfo } = this.state;
            streetAdressInfo.ntasAddrID = obj.AddressId;
            streetAdressInfo.baseAddressId = "0";
            streetAdressInfo.street = street;
            this.setState({
                streetAdressInfo,
                streetValue: street,
                addressError: false,
                unitError: false
            });
            this.props.selectThisStreetAddress(streetAdressInfo);
            this.props.getMultipleAddrSelections({ street });
        }
    }

    multipleAddrRadioClick = (e) => {
        const { value } = e.target
        if (value === "cantfind") {
            this.setState({
                showModal: value === "cantfind",
                showZip: value === "reEnter"
            })
        } else if (value === "reEnter") {
            this.setState({
                showModal: value === "cantfind",
                showZip: value === "reEnter"
            })
            this.props.populateHasMutipleAddress(false);
            this.props.resetZipcodeForm('');
        } else {
            const selectedItem = find(this.props.addressQualificationDetails.AddressList, ['ParsedRawString', value])
            // this.getStreetValue(value);
            if (selectedItem) {
                this.getFormatedAddress(selectedItem);

            } else {
                this.props.selectThisStreetAddress({ street: value });
            }
            // this.props.getStreetAddress(value); 
            this.props.resetDoLoopFlags();
        }
        this.props.postUIEventLog({ eventType: 'log', eventName: "Multiple Address Radio Input", sectionName: "LQ", log: value });
    }

    newService = (e) => {
        this.setState({ isNewService: e.target.value });
    }

    priceQuote = (value) => {
        this.setState({ hasPriceQuote: value })
    }

    showPendingOrderPage = (e, hasQuote) => {
        if (this.state.hasPriceQuote === "Y" || hasQuote) {
            window.sessionStorage.setItem('optixQuoteNum', this.props.priceQuoteNumber);
            SiteAnalytics.trackOptixQuoteNumber(this.props.priceQuoteNumber);
            SiteAnalytics.trackLQPageSelectedQuoteOption("Review/access existing quote selected");
            this.props.history.push("/optix-checkout");
        }
        else if (this.state.isNewService === 'Y' && this.props.addressData.hasPendingOrder) {
            SiteAnalytics.trackLQPageSelectedQuoteOption("Setup a new service selected");
            SiteAnalytics.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
            SiteAnalytics.trackProductsList(window.LQResponse);
            this.props.disableCheckAvailblity(false);
        } else if (this.state.isNewService === 'Y' && !this.props.addressData.hasPendingOrder) {
            // if (this.props?.addressQualificationDetails?.AddressIdPresent !== "Y" && !isNightTimeWindow()) {
            if ( !isNightTimeWindow()) {
                SiteAnalytics.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                SiteAnalytics.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                SiteAnalytics.trackLQPageSelectedQuoteOption("Setup a new service selected");
                SiteAnalytics.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                SiteAnalytics.trackProductsList(window.LQResponse);
                if (window?.newrelic?.addPageAction) {
                    window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                    window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                }
            }
            this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
        } else {
            // Redirect to login - Need to change
            SiteAnalytics.trackLQPageSelectedQuoteOption("Add or change existing service selected");
            SiteAnalytics.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
            SiteAnalytics.trackProductsList(window.LQResponse);
            window.location.href = EXISTING_USER_URL;
        }
    }

    continuePendingOrder = (value) => {
        SiteAnalytics.trackOrderStatus(value);
        if (window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction(`Pending Order ${value ? 'Yes' : 'No'} Button Click`, { data: window.LQRequestBody });
        }
        if (!value) {
            // if (this.props?.addressQualificationDetails?.AddressIdPresent !== "Y" && !isNightTimeWindow()) {
            if ( !isNightTimeWindow()) {

                SiteAnalytics.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                SiteAnalytics.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                if (window?.newrelic?.addPageAction) {
                    window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                    window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                }
            }
        }
        value ? this.props.history.push("/pending-order") : this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
        this.props.postUIEventLog({ eventType: 'log', eventName: "Continue Pending Order Button Click", sectionName: "LQ", log: "" });
    }

    handleBackClickEvent = () => {
        this.props.enableCheckAvailabilityButton(true);
        this.props.enableCheckAvailblity(true);
        this.props.postUIEventLog({ eventType: 'log', eventName: "Pending Order Back Button Click", sectionName: "LQ", log: "" });
    }

    setCityState = (e,value) => {
        let userInput = e?.target?.value;
        if(userInput) {
           // userInput = userInput.trim();
            let data ={
                zip:this.props.selectedZipcode.zip,
                altCity:"",
                state:""
            }
            if(value == "City")  {
            data ={
                    zip:this.props.selectedZipcode.zip,
                    altCity:userInput,
                    state:this.props.selectedZipcode.state
                }
            } else{
                 data ={
                    zip:this.props.selectedZipcode.zip,
                    altCity:this.props.selectedZipcode.altCity,
                    state:userInput
                }
            }
                this.props.setCityAndState(data);
             
        }
    }

    render() {
        const fiosAem = this.props.t("fios", { ns: "fios",returnObjects:true })
        const { showZip, showModal, showIEBanner} = this.state;
        const {
            streetAddressSuggestionList,
            addressQualificationDetails,
            optixAddressQualificationDetails,
            selectedZipcode,
            selectedStreetAddress,
            enableCheckAvailability,
            unitList,
            hasMultipleAddress,
            selectedUnit,
            unitsTriggered,
            unitsResponded
        } = this.props;
        let cityAndState = (selectedZipcode && selectedZipcode.city && selectedZipcode.state) ? selectedZipcode.city + ' , ' + selectedZipcode.state : '';

        let disableButton = !selectedStreetAddress ? true :
            selectedStreetAddress && (!unitsTriggered || !unitsResponded) && !selectedUnit ? true :
                    selectedStreetAddress && unitsResponded && unitsTriggered && unitList && !selectedUnit ? true : false;
        let addressAvailability=false;                
        let unitListArray=[];
            if(selectedStreetAddress&&unitList){
              addressAvailability=Object.keys(selectedStreetAddress).length>0&&unitList.length>0?true:false;
              unitListArray = unitList.filter(elem => elem.unit != null);    
             }  
                    return (
            <div ref={this.mainRef}>
                {fiosAem.showProgressBarLQ ? 
                <VZStepper/>:<></>}

                	<div id="dvAutopay" className="hideSection"></div>
                    {isIEBrowser() && showIEBanner &&
                 <Notification type="warning" className ="ie-banner">
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}><p style={{ marginRight: '20px', lineHeight: '1.2rem' }}> Your web browser is out of date<br />
                    <p style={{fontWeight: 'normal', marginTop:0, marginBottom:2}}>For the best browser experience, please use latest version of chrome, safari, Firrefox and Microsoft </p>
              </p><Button onClick={() => { this.setState({ showIEBanner: false }) }} secondary size="small" >Ignore</Button>
                </div>
                    </Notification>}
                {enableCheckAvailability ? (
                    <React.Fragment>
                    <div className="address-section">
                    <ModGrid className="address-validation" colGutter={false} adSpaceHeight={this.state.adSpaceHeight} >
                        <Row>
                            <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }}>
                                {this.props.toggleLoadingSpinner && this.props?.addressData?.chkAvailibtyClicked ? <SpinnerComponent /> : ""}
                                <div className="Banner Banner-Title mob-vw-mr-tp-75">
                                    {
                                        isMobile ? (
                                            <Title size="large" primitive="h1">
                                              Find out what business  internet service is available in your location
                                            </Title>
                                        )  : (
                                            <Feature size="large" primitive="h1">
                                            Find out what business <br/> internet service is available <br/> in your location
                                         </Feature>
                                        )
                                    }
                                   
                                    {/* <div className="Banner-Content">
                                        <Subtitle primitive="h4">Get exclusive online offers. </Subtitle>
                                    </div> */}
                                </div>
                            </Col>
                            {/* {this.props.lqPageAds && isBrowser ?
                                <Col colSizes={{ "mobile": 4, "tablet": 3, "desktop": 3 }}>
                                    <div ref={this.adRef}>
                                        <InnerHTML html={this.props.lqPageAds} />
                                    </div>
                                </Col>
                                :
                                <></>
                            } */}
                        </Row>
                    </ModGrid>
                    <ModGrid className="form-section">
                        <Row>
                            <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }} className="form-container">
                            <ChatLink style={{ float: "right", paddingTop: "1rem" }} gbcom="gbcom-chat-link" newgbcomId ="eComProspectLP"/>
                                {showZip && !hasMultipleAddress && (
                                    <div className="loop-qualification-content">
                                        {/* <Zipcode
                                            getZipcodes={this.props.getZipcodes}
                                            zipcodeSuggestionList={this.props.zipcodeSuggestionList}
                                            zipcodeEnteredByUser={this.props.zipcodeEnteredByUser}
                                            selectThisZipcode={this.selectThisZipcode}
                                            inputRef={(r) => { this.r = r }}
                                            selectedZipcode={selectedZipcode}
                                            cityAndState={cityAndState}
                                            postUIEventLog={this.props.postUIEventLog}
                                        />
                                        {this.props.zipcodeEnteredByUser && selectedZipcode && cityAndState ? (
                                            <ReadOnlyInput readOnly label="City" value={cityAndState} width={'100%'}></ReadOnlyInput>
                                        ) : null} */}
                                        {/* {this.props.zipcodeEnteredByUser && selectedZipcode ? ( */}
                                            <StreetAddress
                                                showCurrentLocation = {true}
                                                currentLocationFetchError = {this.props.addressData.currentLocationFetchError}
                                                setCurrentLocationFetchError= {()=>this.props.currentLocationFetchError(false)}
                                                selectedZipcode={selectedZipcode}
                                                address={selectedStreetAddress}
                                                getStreetAddress={this.props.getStreetAddress}
                                                streetAddressSuggestionList={streetAddressSuggestionList}
                                                streetTermEnteredByUser={this.props.streetTermEnteredByUser}
                                                selectThisStreetAddress={this.selectedStreetAddress}
                                                getUnits={this.props.getUnits}
                                                getStreetValue={this.getStreetValue}
                                                onDropdownListDismiss={this.onDropdownListDismiss}
                                                inputRef={(r) => { this.r = r }}
                                                handleModal={this.handleModal}
                                                addressError={this.state.addressError}
                                                triggerAddressQualification={this.triggerAddressQualification}
                                                history={this.props.history}
                                                resetDoLoopFlags={this.props.resetDoLoopFlags}
                                                lqStreetAddrError={this.props.addressData.lqStreetAddrError}
                                                postUIEventLog={this.props.postUIEventLog}
                                                setDontShowUnit={this.props.setDontShowUnit}
                                                setAddressFieldError={() => { this.setState({
                                                    addressError: true
                                                })}}
                                                currentLocationClicked = {()=>{
                                                    const geo = navigator.geolocation
                                                    if(geo){
                                                        geo.getCurrentPosition(({coords,timestamp})=>{
                                                            if(coords){
                                                                const {latitude="",longitude=""} = coords
                                                                this.props.fetchLocusInfo({latitude:latitude,longitude:longitude})
                                                            }
                                                        },(data)=>{
                                                        })
    
                                                }
                                                }}
                                            />
                                        {/* ) : null} */}
                                        {addressAvailability===true || LQ_UNIT_ENABLE==='true' ?(
                                            <Unit
                                                showUnit = {true}
                                                selectedStreetAddress = {selectedStreetAddress}
                                                unitList={unitListArray?unitListArray:null}
                                                selectThisUnit={this.selectThisUnit}
                                                showCheckAvailability={this.props.showCheckAvailability}
                                                selectedUnit={unitList?this.props.selectedUnit:null}
                                                totalUnits={unitList?this.props.totalUnits:0}
                                                getUnitsByUnitterm={unitList?this.props.getUnitsByUnitterm:null}
                                                 inputRef={(r) => { this.r = r }}
                                                triggerAddressQualification={this.triggerAddressQualification}
                                                resetDoLoopFlags={this.props.resetDoLoopFlags}
                                                unitError={this.state.unitError}
                                                validateUnits={this.validateUnits}
                                                streetAdressInfo={this.state.streetAdressInfo}
                                                emptyUnitsError={this.props.addressData.emptyUnitsError}
                                                baseAddrUnitError={this.props.addressData.baseAddrUnitError}
                                                postUIEventLog={this.props.postUIEventLog}
                                                iDontLiveUnit={this.props.addressData.iDontLiveUnit}
                                            />
                                        ) : null}
                                        {/* {(selectedStreetAddress) ? ( */}
                                            <CheckAvailability
                                            savePhoneNumber={this.props.savePhoneNumber}
                                            savePriceQuoteNumber={this.props.savePriceQuoteNumber}
                                            phoneNumber={this.props.phoneNumber}
                                            saveEmailAddress={this.props.saveEmailAddress}
                                            emailAddress={this.props.emailAddress}
                                            triggerAddressQualification={this.triggerAddressQualification}
                                            history={this.props.history}
                                            validateAddress={this.validateAddress}
                                            isExistingCustomer={this.props.isExistingCustomer}
                                            addressQualificationDetails={addressQualificationDetails}
                                            setExistingCustomer={this.props.setExistingCustomer}
                                            hasPendingOrder={this.props.hasPendingOrder}
                                            showSpinner={this.props.showSpinner}
                                            streetAddressSuggestionList={this.props.streetAddressSuggestionList}
                                            setHasMutipleAddress={this.props.populateHasMutipleAddress}
                                            streetAdressInfo={this.state.streetAdressInfo}
                                            streetValue={this.state.streetValue}
                                            selectedStreetAddress={this.selectedStreetAddress}
                                            selectedUnit={this.props.selectedUnit}
                                            selectedZipcode={selectedZipcode}
                                            cityAndState={cityAndState}
                                            getUnits={this.props.getUnits}
                                            disableCheckAvailblity={this.props.disableCheckAvailblity}
                                            resetDoLoopFlags={this.props.resetDoLoopFlags}
                                            checkAvailAPICall={this.props.checkAvailAPICall}
                                            validateUnits={this.validateUnits}
                                            postUIEventLog={this.props.postUIEventLog}
                                            disableButton={disableButton}
                                            optixAddressQualificationDetails={optixAddressQualificationDetails}
                                            t={this.props?.t}
                                        />
                                        {/* ) :null} */}
                                            

                                    </div>
                                )}

                                {hasMultipleAddress && (
                                    <AddressConfirmation
                                        streetAddressSuggestionList={addressQualificationDetails.AddressList}
                                        triggerAddressQualification={this.triggerAddressQualification}
                                        multipleAddrRadioClick={this.multipleAddrRadioClick}
                                        history={this.props.history}
                                        postUIEventLog={this.props.postUIEventLog}
                                    />
                                )}

                            {/* {this.props.isExistingCustomer ? (
                                    <ExistingCustomer
                                        newService={this.newService}
                                        previousHasExistingService={this.props.addressData.previousHasExistingService === 'Y' ? this.props.addressData.previousHasExistingService : 'N'}
                                        showPendingOrderPage={this.showPendingOrderPage}
                                        phoneNumber={this.props.phoneNumber}
                                        emailAddress={this.props.emailAddress}
                                        priceQuoteNumber={this.props.priceQuoteNumber}
                                        savePriceQuoteNumber={this.props.savePriceQuoteNumber}
                                        saveOptixMonNumber={this.props.saveOptixMonNumber}
                                        priceQuote={this.priceQuote}
                                        validateAddress={this.validateAddress}
                                        addressQualificationDetails={addressQualificationDetails}
                                        optixAddressQualificationDetails={optixAddressQualificationDetails}
                                        postUIEventLog={this.props.postUIEventLog}
                                    />
                                ) : ''}  */}
                            </Col>
                        </Row>
                        <Row className="Help-Tips">
                            <Col colSizes={{ "mobile": 4, "tablet": 6, "desktop": 6 }}>
                                {showModal &&
                                    <AddressTipsModal opened={showModal} onOpenedChange={this.handleModal}>
                                        <ModalTitle>
                                            <Title size="small" typescale="MVP">Tips for entering address information.</Title>
                                        </ModalTitle>
                                        <ModalBody>
                                            <Body size="medium" typescale="MVP" viewport="desktop" primitive="h2">
                                                <UnorderedList>
                                                    <ListItem size="bodyMedium" viewport="desktop">Don't use a P.O. box.</ListItem>
                                                    <ListItem size="bodyMedium" viewport="desktop">Use abbreviations (N, S, E, W) for directions (North, South, East and West) before street names, like "4 S Log Road" or "26 E 7 Street."</ListItem>
                                                    <ListItem size="bodyMedium" viewport="desktop">With the noted exception above, write out all words in the address completely, like "Drive", "Avenue" or "Street".</ListItem>
                                                    <ListItem size="bodyMedium" viewport="desktop">Include your building, floor and unit number if applicable.</ListItem>
                                                    <ListItem size="bodyMedium" viewport="desktop">Add a space between numbers and letters.</ListItem>
                                                </UnorderedList>
                                            </Body>
                                            <Body size="medium" typescale="MVP" viewport="desktop" primitive="h2">Give us a call at 1-888-720-9944 if you need any help.
                                                </Body>
                                        </ModalBody>
                                    </AddressTipsModal>
                                }
                            </Col>
                        </Row>

                        {/* {!hasMultipleAddress ?
                            (<Row className="signin-section">
                                <Col colSizes={{ "mobile": 4, "tablet": 6, "desktop": 6 }}>
                                    {selectedZipcode && cityAndState ? <Body size="large" >Need help? <TextLink onClick={() => { this.setState({ showModal: true }) }}>Read our tips</TextLink> on filling out this form.</Body> : null}
                                    <br />
                                    <MarginSpacerM></MarginSpacerM>
                                    <Body size="large">Already a customer? <TextLink onClick={handleSignInClickEvent}>Sign in now.</TextLink></Body>
                                </Col>
                            </Row>
                            ) : <Row><Col colSizes={{ "mobile": 4, "tablet": 6, "desktop": 6 }}>  </Col></Row>} */}
 
                             
                        {/* {this.props.lqPageAds && isMobile ?
                            <Row>
                                <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }}>
                                    <InnerHTML html={this.props.lqPageAds}/>
                                   
                                </Col>
                            </Row> : <></>
                        } */}
                         {!isMobileOnly ? (
                        <Row className="disclosure-section">
                                <Col  className="disclosure-section-col" colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }}> 
                                    <MarginSpacerM></MarginSpacerM>
                                    <Micro>Verizon may occasionally have products or services that we think may be of interest to you. By submitting this form, you give Verizon your consent to use automated technology to call and text you with marketing and promotional messages at the phone number(s) above, including your wireless number if provided. Consent is not required to purchase Verizon services.You also understand you will receive marketing and promotional emails from Verizon with information and deals on our products and services. We respect your privacy. Please see Verizon's 
                                        <TextLink onClick = {()=>window.open('https://www.verizon.com/about/privacy/')}> Privacy Policy</TextLink>. 
                                        California residents can view our 
                                        <TextLink onClick = {()=>window.open('https://www.verizon.com/about/privacy/full-privacy-policy?scrollto=index-1#acc-item-55')}> California Privacy Notice</TextLink>
                                        .
                                    </Micro>
                                    
                                </Col>
                            </Row>) 
                            : <></>}
                    </ModGrid >
                 
                    </div>
                    <ModGrid >
                            <Row>
                                <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }}  className="external-links">
                                    {/* <Body >
                                        <TextLink
                                            type="inline" 
                                            inverted={false}
                                            disabled={false}
                                            onClick={e => {
                                                window.location.href="https://www.verizon.com/home/";
                                            }}>
                                            Shopping for personal use? 
                                        </TextLink>
                                    </Body> */}
                                    <Body >
                                    <TextLink
                                        type="inline" 
                                        inverted={false}
                                        disabled={false}
                                        onClick={e => {
                                            window.location.href="https://www.verizon.com/business/solutions/enterprise/";
                                        }}>
                                         Shopping for Enterprise use? 
                                    </TextLink>
                                    </Body>  
                                </Col>
                            </Row>
                            {isMobileOnly ? (
                                <Row className="disclosure-section">
                                    <Col  className="disclosure-section-col" colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }}> 
                                        <MarginSpacerL></MarginSpacerL>
                                        <Micro>Verizon may occasionally have products or services that we think may be of interest to you. By submitting this form, you give Verizon your consent to use automated technology to call and text you with marketing and promotional messages at the phone number(s) above, including your wireless number if provided. Consent is not required to purchase Verizon services.You also understand you will receive marketing and promotional emails from Verizon with information and deals on our products and services. We respect your privacy.</Micro>
                                    </Col>
                                </Row>) 
                            : <></>}
                    </ModGrid>
                     {/* {this.props.lqPageAds ?
                           <div  className="ads-section">
                                <Row>
                                    <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }} className="container-section">
                                        <div className="header-section">
                                            Enter your address to see <br/> if you qualify for these  <br/>online offers
                                        </div>
                                        <InnerHTML html={this.props.lqPageAds}/>
                                    
                                    </Col>
                                </Row>
                            </div>
                            : <></>
                        } */}
                      
                    </React.Fragment>
                )
                    :
                    // this.props.addressData.hasPendingOrder ? (
                    //     <PendingOrder
                    //         PendingOrderCallback={this.continuePendingOrder.bind(this)}
                    //         handleBackClickEvent={this.handleBackClickEvent}
                    //         postUIEventLog={this.props.postUIEventLog}
                    //     />
                    // ) : 
                    <></>
                }
            </div >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        addressData: state.AddressValidationPage
    };
};

const mapDispatchToProps = (dispatch) => ({
    populateHasMutipleAddress: (data) => { dispatch(setHasMutipleAddress(data)); },
    enableCheckAvailblity: (data) => { dispatch(enableCheckAvailblity(data)); },
    disableCheckAvailblity: (data) => { dispatch(disableCheckAvailblity(data)); },
    enableCheckAvailabilityButton: (data) => { dispatch(enableCheckAvailblityButton(data)); },
    resetZipcodeForm: (data) => { dispatch(resetZipcodeForm(data)); },
    setBannerInfo: (data) => { dispatch(setBannerInfo(data)); },
    setNewAddressFlow: (data) => { dispatch(setNewAddressFlow(data)); },
    setExistingCustomer: (data) => { dispatch(setExistingCustomer(data)); },
    hasPendingOrder: (data) => { dispatch(hasPendingOrder(data)); },
    presetAddressinfo: (data) => { dispatch(setAddressInfo(data)) },
    redirectLBOPage: (data) => { dispatch(redirectLBOPage(data)) },
    hideGlobalErrorMessage: () => { dispatch(toggleGlobalErrorMessage({ enableNotification: false })) },

    //for chat integration
    getChatInfo: (data) => dispatch(getChatInfo(data)),
    showSpinner: (data) => { dispatch(showSpinner(data)); },
    resetDoLoopFlags: () => { dispatch(resetDoLoopFlags()) },
    checkAvailAPICall: (data) => { dispatch(checkAvailAPI(data)) },
    setEmptyUnitsError: (data) => { dispatch(setEmptyUnitsError(data)) },
    saveCurrentLocation: (data) => { dispatch(saveCurrentLocation(data)) },
    multipleAddrSelectionsWithId: (data) => { dispatch(multipleAddrSelectionsWithId(data)) },
    postUIEventLog: (data) => { dispatch(postUIEventLog(data)) },
    setDontShowUnit: (data) => { dispatch(setDontShowUnit(data)) },
    setCityAndState: (data) => { dispatch(setCityAndState(data)) },
    getLqPageAds: (data) => dispatch(getLqPageAds(data)),
    setRedirectedFrom: (data) => dispatch(setRedirectedFrom(data)),
    setcmpCodeQueryParams: (data) => dispatch(setcmpCodeQueryParams(data)),
    setcmpCodeQueryParamsWireless: (data) => dispatch(setcmpCodeQueryParamsWireless(data)),
    fetchLocusInfo: (data) => dispatch(fetchLocusInfo(data)),
    currentLocationFetchError: (data) => dispatch(currentLocationFetchError(data)),
    selectThisUnitAddress: (data) => dispatch(selectThisUnitAddress(data)),
    useLocusApi: (data) => dispatch(useLocusApi(data)),
    setBannerId: (data) => dispatch(setBannerId(data)),
});

AddressValidationPage = connect(mapStateToProps, mapDispatchToProps)(AddressValidationPage);
export default withTranslation("fios", { withRef: true })(AddressValidationPage);
